import { useState } from "react";
import { useNavigate, useParams, useRevalidator, useRouteLoaderData } from "react-router-dom";
import LocatorForm from "src/components/outside/locator/locatorForm";
import { LocatorWeekData, Division } from "./actions_loaders";

type LoaderData = {
    week: string;
    locator: {
        id: string;
        email: string;
        userName: string;
        lanId?: string;
        outside: string;
    };
    weekData: LocatorWeekData;
    divisions: Division[];
};

export default function AllLocatorDayEdit() {
    const { week, locator, weekData, divisions } = useRouteLoaderData("AllLocatorDetail") as LoaderData;
    const { dayIndex } = useParams();
    const navigate = useNavigate();
    const revalidator = useRevalidator();
    const [localWeekData, setLocalWeekData] = useState(weekData);
    const index = Number(dayIndex ?? 0);

    return (
        <LocatorForm
            closeIt = {() => {
                revalidator.revalidate();
                navigate(`/OutsideStatus/${week}/${locator.id}`);
            }}
            defaultData = {localWeekData}
            week = {week}
            dayIndex = {index}
            admin = {true}
            userId = {locator.id}
            email = {locator.email}
            userName = {locator.userName}
            lanId = {locator.lanId}
            outside = {locator.outside}
            divisions = {divisions}
            onWeekFormChange = {setLocalWeekData}
        />
    );
}
